import React, { useEffect, useState } from "react";
import { CgAdd, CgChevronDown, CgChevronUp } from "react-icons/cg";
import { useAuth } from "../../../../Contexts/AuthContext/AuthContext";
import { useProperty } from "../../../../Contexts/PropertyContext/PropertyContext";
import { toast } from "react-toastify";
import { baseUrl } from "../../../../Environments/environment";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";
import { Switch } from "@headlessui/react";
import { FaEye, FaTrash } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import NewFlowModal from "./NewFlowModal";
import RoomType from "../../../RoomTypeModal/RoomType.jsx";
import TierType from "../../../TierTypeModal/TierType.jsx";
import Ac from "../../../SvgComponents/AC.jsx";
import Breakfast from "../../../SvgComponents/Breakfast.jsx";
import Breakfast2 from "../../../SvgComponents/Breakfast2.jsx";
import Commute from "../../../SvgComponents/Commute.jsx";
import Frontdesk from "../../../SvgComponents/Frontdesk.jsx";
import Gym from "../../../SvgComponents/Gym.jsx";
import HomeService from "../../../SvgComponents/HomeService.jsx";
import Laundry from "../../../SvgComponents/Laundry.jsx";
import Luggae2 from "../../../SvgComponents/Luggae2.jsx";
import Luggage from "../../../SvgComponents/Luggage.jsx";
import Minibar from "../../../SvgComponents/Minibar.jsx";
import Parking from "../../../SvgComponents/Parking.jsx";
import Pet from "../../../SvgComponents/Pet.jsx";
import Spa from "../../../SvgComponents/Spa.jsx";
import Swimming from "../../../SvgComponents/Swimming.jsx";
import Wheelchair from "../../../SvgComponents/Wheelchair.jsx";
import Wifi from "../../../SvgComponents/Wifi.jsx";
import Wine from "../../../SvgComponents/Wine.jsx";
import Tv from "../../../SvgComponents/TV.jsx";
import { apiClient } from "../../../../api/index.js";
import { Info } from "lucide-react";
const arr = [
	<Wifi />,
	<Breakfast />,
	<HomeService />,
	<Gym />,
	<Swimming />,
	<Luggae2 />,
	<Breakfast2 />,
	<Frontdesk />,
	<Parking />,
	<Ac />,
	<Minibar />,
	<Laundry />,
	<Commute />,
	<Pet />,
	<Wine />,
	<Spa />,
	<Tv />,
	<Luggage />,
	<Wheelchair />,
];
const obj = {
	freeWiFi: Wifi,
	complimentaryBreakfast: Breakfast2,
	roomService: HomeService,
	fitnessCenterGym: Gym,
	swimmingPool: Swimming,
	businessCenter: Luggae2,
	onSiteRestaurantBar: Wine,
	conciergeService: Breakfast,
	parking: Parking,
	airConditioningHeating: Ac,
	frontDesk: Frontdesk,
	laundryServices: Laundry,
	airportShuttleService: Commute,
	petFriendlyAccommodations: Pet,
	miniBar: Minibar,
	spaWellnessCenter: Spa,
	cableSatelliteTV: Tv,
	luggageStorage: Luggage,
	wheelchairAccessibility: Wheelchair,
};

const ConfirmModal = ({ open, review, onConfirm, onCancel }) => {
	if (!open || !review) return null;
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
			<div className="bg-white w-full max-w-md rounded-lg shadow-xl p-4 sm:p-6">
				<h3 className="text-base sm:text-lg font-semibold mb-2">
					Are you sure want to delete this review job?
				</h3>
				<div className="mb-4 text-gray-700 text-sm">
					<span className="font-semibold ">Network:</span> {review?.network}
					<br />
					<span className="font-semibold ">Review Job ID:</span>{" "}
					{review?.reviewJobId}
				</div>
				<div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
					<button
						onClick={onCancel}
						className="px-4 py-2 text-sm sm:text-base rounded bg-gray-200 hover:bg-gray-300 w-full sm:w-auto"
					>
						No
					</button>
					<button
						onClick={onConfirm}
						className="px-4 py-2 text-sm sm:text-base rounded bg-indigo-600 text-white hover:bg-indigo-700 w-full sm:w-auto"
					>
						Yes
					</button>
				</div>
			</div>
		</div>
	);
};

export const Workflow = () => {
	const { accessToken } = useAuth();
	const { selectedPropertyId } = useProperty();
	const [loading, setLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [activate, setActivate] = useState(true);
	const [workflowData, setWorkflowData] = useState();
	const [selectedAmenities, setSelectedAmenities] = useState([]);
	const [isNewFlowModalOpen, setIsNewFlowModalOpen] = useState(false);
	const [isRoomTypeModalOpen, setIsRoomTypeModalOpen] = useState(false);
	const [selectedRoomData, setSelectedRoomData] = useState(null);
	const [roomTypeAction, setRoomTypeAction] = useState(null);
	const [tierTypeAction, setTierTypeAction] = useState(null);
	const [selectedTierData, setSelectedTierData] = useState(null);
	const [isTierTypeModalOpen, setIsTierTypeModalOpen] = useState(false);
	const [tierType, setTierType] = useState([]);
	const [roomType, setRoomType] = useState([]);

	// RoomType Modal handlers
	const openRoomTypeModal = (roomData, action) => {
		// If roomData exists, add tierType name using getTierNameById
		if (roomData) {
			const tierName = getTierNameById(
				roomData.tierTypeId,
				addOnsFlow.upgradeRoom.tiers,
			);
			const enhancedRoomData = {
				...roomData,
				tierType: tierName,
			};
			setSelectedRoomData(enhancedRoomData);
		} else {
			setSelectedRoomData(roomData);
		}
		setRoomTypeAction(action);
		setIsRoomTypeModalOpen(true);
	};

	const closeRoomTypeModal = () => {
		setIsRoomTypeModalOpen(false);
		setSelectedRoomData(null);
	};

	const openTierTypeModal = (tierData, action) => {
		setSelectedTierData(tierData);
		setTierTypeAction(action);
		setIsTierTypeModalOpen(true);
	};

	const closeTierTypeModal = () => {
		setIsTierTypeModalOpen(false);
		setSelectedTierData(null);
	};

	const [isExpandedHome, setIsExpandedHome] = useState(false);
	const [isExpandedAmenities, setIsExpandedAmenities] = useState(false);
	const [isExpandedArrival, setIsExpandedArrival] = useState(false);
	const [isFaqEnabled, setIsFaqEnabled] = useState(false);
	const [isExpandedInHouse, setIsExpandedInHouse] = useState(false);
	const [isExpandedReviews, setIsExpandedReviews] = useState(false);
	const [isExpandedCheckedOut, setIsExpandedCheckedOut] = useState(false);
	const [isExpandedAddOns, setIsExpandedAddOns] = useState(false);
	const [faqList, setFaqList] = useState([]);
	const [flowUpdateLoader, setFlowUpdateLoader] = useState(false);
	const [hoveredIndex, setHoveredIndex] = useState(null);
	const [preArrivalData, setPreArrivalData] = useState({
		phoneNumber: true,
		emailAddress: true,
		arrivalTime: true,
		vehicleMakeModelColor: true,
		licensePlateNo: true,
		specialRequests: true,
		guestSignature: true,
		guestIdProof: true,
		policies: true,
		primaryPolicy: "",
		policyLink: "",
		extraPolicies: [],
	});
	const [inHouseFlow, setInHouseFlow] = useState({
		wifiDetailsEnabled: false,
		wifiDetails: { wifiName: "", wifiInstructions: "" },
		clickableLinksOrButtonsEnabled: false,
		clickableLinksOrButtons: [],
		frequentlyAskedQuestionsEnabled: false,
		frequentlyAskedQuestions: [],
	});

	const [checkedOutFlow, setCheckedOutFlow] = useState({
		frequentlyAskedQuestionsEnabled: false,
		frequentlyAskedQuestions: [{ question: "", answer: "" }],
	});

	const [addOnsFlow, setAddOnsFlow] = useState({
		customAddOns: [
			{
				name: "",
				description: "",
				addonNote: "",
				paid: false,
				price: 0,
				enabled: false,
				default: false,
			},
		],
		checkInOutAddOns: [
			{
				name: "",
				description: "",
				addonNote: "",
				defaultTimeEnabled: false,
				defaultTiming: "",
				customTiming: "",
				paid: false,
				price: 0,
				enabled: false,
				default: false,
			},
		],
		houseKeepingAddOns: {
			name: "House Keeping",
			description: "",
			enabled: false,
			default: true,
			options: [],
		},
		upgradeRoom: {
			name: "Upgrade Room",
			default: true,
			image: [],
			options: [],
			tiers: [],
		},
	});

	const [reviewsFlow, setReviewsFlow] = useState({
		reviewsLink: "",
		startLimitForReviewLink: 1,
	});
	console.log("setReviewsFlow", reviewsFlow);

	// Reviews Job Flow state
	const [reviewsJobFlow, setReviewsJobFlow] = useState({
		reviewJobs: [],
	});
	// setReviewsJobFlow({
	//   reviewJobs: [
	//     {
	//       _id: "68e13010af4eb5f286270f47",
	//       propertyId: "66a2174cf74f8664b0bb207d",
	//       network: "agoda",
	//       reviewJobId: "3e7033be-c07f-4092-ace5-13f693e24031",
	//       slug: "warfield-hotel/reviews/san-francisco-ca-us",
	//       uid: "35da7515-6f4e-4cd6-8252-373f80c55451",
	//       networkUrl:
	//         "https://www.agoda.com/warfield-hotel_2/hotel/san-francisco-ca-us.html",
	//       createdAt: "2025-10-04T14:32:48.225Z",
	//       updatedAt: "2025-10-04T14:32:48.225Z",
	//       __v: 0,
	//     },
	//   ],
	// });
	console.log("reviewsJobFlow", reviewsJobFlow);
	const [isAddingReviewJob, setIsAddingReviewJob] = useState(false);
	const [isUpdatingReviewJob, setIsUpdatingReviewJob] = useState(false);
	const [editingJobId, setEditingJobId] = useState(null);
	const [newReviewJob, setNewReviewJob] = useState({
		network: "",
		networkUrl: "",
		redirectUrl: "",
	});
	const [editingReviewJob, setEditingReviewJob] = useState({
		network: "",
		networkUrl: "",
		redirectUrl: "",
	});

	// Available networks for review jobs
	const availableNetworks = [
		{ value: "google", label: "Google" },
		{ value: "tripadvisor", label: "TripAdvisor" },
		{ value: "yelp", label: "Yelp" },
		{ value: "booking", label: "Booking.com" },
		{ value: "expedia", label: "Expedia" },
		{ value: "agoda", label: "Agoda" },
	];
	const [confirmModal, setConfirmModal] = useState({
		open: false,
		review: null,
	});

	// Get available networks excluding already used ones (for add mode)
	const getAvailableNetworks = () => {
		const usedNetworks = reviewsJobFlow.reviewJobs.map((job) => job.network);
		return availableNetworks.filter(
			(network) => !usedNetworks.includes(network.value),
		);
	};

	// Get available networks for editing (include current network)
	const getAvailableNetworksForEdit = (currentNetwork) => {
		const usedNetworks = reviewsJobFlow.reviewJobs
			.filter((job) => job._id !== editingJobId)
			.map((job) => job.network);
		return availableNetworks.filter(
			(network) =>
				!usedNetworks.includes(network.value) ||
				network.value === currentNetwork,
		);
	};

	const handleAddReviewJob = async () => {
		if (
			!newReviewJob.network ||
			!newReviewJob.networkUrl ||
			!newReviewJob.redirectUrl
		) {
			toast.error("Please fill in all fields");
			return;
		}

		try {
			setIsAddingReviewJob(true);
			const token = localStorage.getItem("accessToken");

			const response = await apiClient.post(
				`${baseUrl}/reviews/jobs/${selectedPropertyId}`,
				{
					network: newReviewJob.network,
					networkUrl: newReviewJob.networkUrl,
					redirectUrl: newReviewJob.redirectUrl,
				},
				{
					headers: { Authorization: `Bearer ${token}` },
				},
			);

			if (response.data.statusCode === 201) {
				toast.success("Review job added successfully!");
				// Reset form
				setNewReviewJob({
					network: "",
					networkUrl: "",
					redirectUrl: "",
				});
				// Refresh review jobs
				fetchReviewJobs();
			}
		} catch (error) {
			console.error("Error adding review job:", error);
			const errorMessage =
				error.response?.data?.message || "Failed to add review job";
			toast.error(errorMessage);
		} finally {
			setIsAddingReviewJob(false);
		}
	};

	const handleUpdateReviewJob = async () => {
		// if (!editingReviewJob.network || !editingReviewJob.networkUrl) {
		//   toast.error("Please fill in all fields");
		//   return;
		// }
		if (!editingReviewJob.redirectUrl) {
			toast.error("Please fill in all fields");
			return;
		}

		try {
			setIsUpdatingReviewJob(true);
			const token = localStorage.getItem("accessToken");

			const response = await apiClient.put(
				`${baseUrl}/reviews/jobs/${selectedPropertyId}/${editingJobId}`,
				{
					// network: editingReviewJob.network,
					// networkUrl: editingReviewJob.networkUrl,
					redirectUrl: editingReviewJob.redirectUrl,
				},
				{
					headers: { Authorization: `Bearer ${token}` },
				},
			);

			if (response.data.statusCode === 200) {
				toast.success("Review job updated successfully!");
				// Exit edit mode
				setEditingJobId(null);
				setEditingReviewJob({
					network: "",
					networkUrl: "",
					redirectUrl: "",
				});
				// Refresh review jobs
				fetchReviewJobs();
			}
		} catch (error) {
			console.error("Error updating review job:", error);
			const errorMessage =
				error.response?.data?.message || "Failed to update review job";
			toast.error(errorMessage);
		} finally {
			setIsUpdatingReviewJob(false);
		}
	};

	const handleEditReviewJob = (job) => {
		setEditingJobId(job._id);
		setEditingReviewJob({
			network: job.network,
			networkUrl: job.networkUrl || job.networkUrl,
			redirectUrl: job.redirectUrl,
		});
	};
	const handleIsDefault = async (jobId, isDefault) => {
		// Update local state immutably
		const updatedJobs = reviewsJobFlow.reviewJobs.map((r) =>
			r._id === jobId ? { ...r, isDefault } : { ...r, isDefault: false },
		);
		setReviewsJobFlow({ reviewJobs: updatedJobs });

		// Find the updated job for API payload
		const updatedJob = updatedJobs.find((r) => r._id === jobId);

		try {
			const token = localStorage.getItem("accessToken");
			const response = await apiClient.put(
				`${baseUrl}/reviews/jobs/${selectedPropertyId}/${jobId}`,
				updatedJob,
				{ headers: { Authorization: `Bearer ${token}` } },
			);

			if (response.data.statusCode === 200) {
				toast.success("Review job updated successfully!");
				setNewReviewJob({ network: "", networkUrl: "", redirectUrl: "" });
				fetchReviewJobs();
			}
		} catch (error) {
			console.error("Error updating review job:", error);
			toast.error(
				error.response?.data?.message || "Failed to update review job",
			);
		} finally {
			setIsAddingReviewJob(false);
		}
	};

	const handleCancelEdit = () => {
		setEditingJobId(null);
		setEditingReviewJob({
			network: "",
			networkUrl: "",
			redirectUrl: "",
		});
	};

	const handleDeleteReviewJob = async () => {
		try {
			const review = confirmModal.review;
			setConfirmModal({ open: false, review: null });
			const jobId = review._id;
			if (jobId) {
				const token = localStorage.getItem("accessToken");

				const response = await apiClient.delete(
					`${baseUrl}/reviews/jobs/${selectedPropertyId}/${jobId}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					},
				);

				if (response.data.statusCode === 200) {
					toast.success("Review job deleted successfully!");
					fetchReviewJobs();
				}
			}
		} catch (error) {
			console.error("Error deleting review job:", error);
			const errorMessage =
				error.response?.data?.message || "Failed to delete review job";
			toast.error(errorMessage);
		}
	};

	const fetchReviewJobs = async () => {
		try {
			const token = localStorage.getItem("accessToken");

			const response = await apiClient.get(
				`${baseUrl}/reviews/jobs/${selectedPropertyId}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				},
			);

			if (response.data.statusCode === 200) {
				setReviewsJobFlow({
					reviewJobs: response.data.result.reviewJobs || [],
				});
			}
		} catch (error) {
			console.error("Error fetching review jobs:", error);
		}
	};

	const preArrivalFlowInputChange = (e) => {
		setPreArrivalData((prev) => ({
			...prev,
			[e.target.name]: e.target.value,
		}));
	};
	const toggleExpandHome = () => {
		setIsExpandedHome(!isExpandedHome);
	};
	const toggleExpandAmenities = () => {
		setIsExpandedAmenities(!isExpandedAmenities);
	};

	const toggleExpandArrival = () => {
		setIsExpandedArrival(!isExpandedArrival);
	};
	const toggleExpandInHouse = () => setIsExpandedInHouse(!isExpandedInHouse);
	const toggleExpandReviews = () => setIsExpandedReviews(!isExpandedReviews);

	const toggleExpandCheckedOut = () => {
		setIsExpandedCheckedOut(!isExpandedCheckedOut);
	};

	const toggleExpandAddOns = () => {
		setIsExpandedAddOns((prev) => !prev);
	};

	const getCustomFlows = async () => {
		try {
			const propertyId = localStorage.getItem("selectedPropertyId");
			const response = await apiClient.get(
				`${baseUrl}/customFlow/${propertyId}`,
			);
			if (response.status === 200) {
				const newToken = response.headers["authorization"];
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]);
				}

				if (response.data?.result?.length > 0) {
					// console.log("DATAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",response.data)
					setCustomFlows([...response.data.result].reverse());
				} else {
					// console.warn("No flows found");
					// console.log(response.data.result)
					setCustomFlows([...response.data.result.customFlow].reverse());
				}
			} else {
				console.error("API error:", response);
			}
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

	function classNames(...classes) {
		return classes.filter(Boolean).join(" ");
	}
	const fetchWorkflow = async () => {
		setLoading(true);

		try {
			const response = await apiClient.get(
				`${baseUrl}/workflow/${selectedPropertyId}`,
			);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			const data = response.data.result;
			console.log("pppppppppppp", data);
			setWorkflowData(data);

			// Reviews Flow
			setReviewsFlow({
				reviewsEnabled: data.reviewFlow && data.reviewFlow.reviewsEnabled,
				reviewsLink: data.reviewFlow && data.reviewFlow.reviewsLink,
				startLimitForReviewLink:
					data.reviewFlow && data.reviewFlow.startLimitForReviewLink,
			});
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Failed to fetch workflow data. Please try again.";
			toast.error(errorMessage);
		} finally {
			setLoading(false);
		}
	};

	const getTemplates = async () => {
		try {
			const response = await apiClient.get(
				`${baseUrl}/messageTemplate/${selectedPropertyId}`,
			);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			console.error("MESSAGE TEMPLATES");
			console.log(response.data.result);
			setTemplates(response.data.result.reverse());
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};
	const [templates, setTemplates] = useState([]);

	const [customFlows, setCustomFlows] = useState([]);

	const getTierNameById = (tierId, tiers) => {
		const tier = tiers.find((t) => t.id === tierId);
		return tier ? tier.tierType : "Unknown Tier";
	};

	useEffect(() => {
		getCustomFlows();
		getTemplates();
	}, [isNewFlowModalOpen]);
	useEffect(() => {
		if (selectedPropertyId) {
			fetchWorkflow();
		}

		getCustomFlows();
		getTemplates();
		fetchReviewJobs(); // Add this line to fetch review jobs
	}, [accessToken, selectedPropertyId]);
	console.log("aaaaaaaaaaaaa", addOnsFlow);
	const handleSaveChanges = async () => {
		setIsLoading(true);
		try {
			// Create a new FormData object
			const formData = new FormData();

			// Add each part of the workflow data to FormData

			// Prepare add-ons flow data
			const addOnsWithImageInfo = {
				...addOnsFlow,

				customAddOns: addOnsFlow.customAddOns.map((addOn, index) => {
					const { image, previewUrl, ...rest } = addOn;
					return {
						...rest,
						image: image, // boolean flag indicating if an image was selected
						imageKey: image ? `addOn_${index}` : null, // unique key for the image if present
					};
				}),
			};

			formData.append("addOnsFlow", JSON.stringify(addOnsWithImageInfo));

			// Append images for each custom add-on with unique keys
			addOnsFlow.customAddOns.forEach((addOn, index) => {
				if (addOn.image) {
					formData.append(`addOn_${index}`, addOn.image);
				}
			});

			formData.append(
				"reviewFlow",
				JSON.stringify({
					...reviewsFlow,
				}),
			);

			// Send the form data using axios
			await apiClient.put(
				`${baseUrl}/workflow/${selectedPropertyId}`,
				formData,
			);

			toast.success("Workflow updated successfully!");
			fetchWorkflow();
			getCustomFlows();
			getTemplates();
		} catch (error) {
			console.error("Error updating workflow:", error);
			const errorMessage =
				error.response?.data?.message ||
				"Failed to update workflow. Please try again.";
			toast.error(errorMessage);
		} finally {
			setIsLoading(false);
		}
	};

	const openNewFlowModal = () => {
		setIsNewFlowModalOpen(true);
	};

	// Function to close the modal
	const closeNewFlowModal = () => {
		setIsNewFlowModalOpen(false);
	};
	const redirectOptions = [
		{ label: "Greater than 1", value: "1" },
		{ label: "Greater than 2", value: "2" },
		{ label: "Greater than 3", value: "3" },
		{ label: "Greater than 4", value: "4" },
	];
	const [expandedFlows, setExpandedFlows] = useState({});

	const toggleExpand = (flowId) => {
		setExpandedFlows((prev) => ({
			...prev,
			[flowId]: !prev[flowId], // Toggle expand state for specific flow
		}));
	};

	const [flowStatuses, setFlowStatuses] = useState({});

	useEffect(() => {
		if (customFlows.length > 0) {
			const initialStatuses = customFlows.reduce((acc, flow) => {
				acc[flow._id] = flow.flowStatus ?? true; // Ensure true if undefined
				return acc;
			}, {});
			setFlowStatuses(initialStatuses);
		}
	}, [customFlows]);

	const toggleFlowStatus = (flowId) => {
		setFlowStatuses((prev) => ({
			...prev,
			[flowId]: !prev[flowId],
		}));
	};

	const handleUpdateWorkFlow = async (flow) => {
		const propertyId = localStorage.getItem("selectedPropertyId");
		const modifiedFlow = {
			...flow,
			flowStatus: flowStatuses[flow._id],
		};
		console.log(modifiedFlow);
		try {
			setFlowUpdateLoader(true);
			const response = await apiClient.put(
				`${baseUrl}/customFlow/${propertyId}`,
				modifiedFlow,
			);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			toast.success(response.data.message);
			// Reset state values after successful API call
			//resetFields();
		} catch (error) {
			console.log(error.response);
			let errorMessage =
				error.response?.data?.message ||
				"Failed to add the guest. Please try again.";
			toast.error(errorMessage);
		} finally {
			setFlowUpdateLoader(false);
		}
		//console.log(flow)
	};

	return (
		<>
			{loading && <LoadingSpinner />}
			<div className="bg-gray-100 p-4 sm:p-6 lg:p-8 xl:p-12">
				<div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4 sticky top-0 bg-gray-100 z-50 py-3">
					<h2 className="text-2xl font-semibold">Workflow</h2>

					<div className="flex flex-col gap-2 sm:flex-row sm:gap-0 w-full sm:w-auto">
						<button
							className="bg-[#4F46E5] hover:bg-indigo-500 text-white font-medium px-2 py-1.5 rounded-md sm:m-2 flex items-center justify-center w-full sm:w-36"
							onClick={openNewFlowModal}
						>
							<CgAdd className="mr-1.5 text-[18px]" />
							New Flow
						</button>

						<button
							onClick={handleSaveChanges}
							className="bg-green-400 hover:bg-green-500 text-white font-medium px-2 py-1.5 rounded-md sm:m-2 w-full sm:w-36"
						>
							{isLoading ? "Saving..." : "Save Changes"}
						</button>
					</div>
				</div>

				<div>
					{customFlows.map((flow) => (
						<div
							key={flow._id}
							className="bg-white shadow-md rounded-lg p-4 sm:p-6 w-full mb-4 sm:mb-6"
						>
							<h3 className="text-lg sm:text-xl font-semibold mb-2">
								{flow.name}
								<span className="text-xs text-gray-500 ml-2">(Custom)</span>
							</h3>
							<p className="text-gray-700 text-sm sm:text-base">
								{flow.description}
							</p>

							<div className="flex justify-end mt-4 bg-gray-50 p-2 rounded-md">
								<button
									onClick={() => toggleExpand(flow._id)}
									className="text-indigo-500 hover:text-indigo-700 flex items-center text-sm"
								>
									{expandedFlows[flow._id] ? (
										<>
											View Less <CgChevronUp className="ml-1" />
										</>
									) : (
										<>
											View All <CgChevronDown className="ml-1" />
										</>
									)}
								</button>
							</div>

							{expandedFlows[flow._id] && (
								<div className="mt-4 bg-gray-50 p-3 sm:p-4 rounded-lg">
									<p className="text-gray-700 font-bold text-sm sm:text-base">
										Trigger Event
									</p>
									<div className="mt-2 sm:mt-4">
										<input
											type="text"
											placeholder="Amenity"
											value={flow.trigger}
											readOnly
											className="border border-gray-300 rounded-md p-2 text-sm sm:text-base w-full mb-2"
										/>
									</div>
									<p className="text-gray-700 font-bold text-sm sm:text-base">
										Trigger Delay
									</p>
									<div className="mt-2 sm:mt-4">
										<input
											type="text"
											placeholder="Amenity"
											value={`${flow.timeDelay} minutes`}
											readOnly
											className="border border-gray-300 rounded-md p-2 text-sm sm:text-base w-full mb-2"
										/>
									</div>
									<p className="text-gray-700 font-bold text-sm sm:text-base">
										Template Name
									</p>
									<div className="mt-2 sm:mt-4">
										<textarea
											value={
												templates.find(
													(msg) => msg._id === flow.messageTemplateId,
												)?.name || "No message template found"
											}
											readOnly
											className="border border-gray-300 rounded-md p-2 text-sm sm:text-base w-full mb-2"
										/>
									</div>

									<p className="text-gray-700 font-bold text-sm sm:text-base">
										Template Description
									</p>
									<div className="mt-2 sm:mt-4">
										<textarea
											value={
												templates.find(
													(msg) => msg._id === flow.messageTemplateId,
												)?.message || "No message template found"
											}
											readOnly
											className="border border-gray-300 rounded-md p-2 text-sm sm:text-base w-full mb-2"
										/>
									</div>

									<div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4 mt-4">
										{/* Switch */}
										<div className="flex items-center gap-2">
											<Switch
												checked={flowStatuses[flow._id]}
												onChange={() => toggleFlowStatus(flow._id)}
												className={classNames(
													flowStatuses[flow._id]
														? "bg-indigo-600"
														: "bg-gray-200",
													"relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2",
												)}
											>
												<span
													aria-hidden="true"
													className={classNames(
														flowStatuses[flow._id]
															? "translate-x-5"
															: "translate-x-0",
														"pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
													)}
												/>
											</Switch>
											<span className="text-sm text-gray-700">Enable Flow</span>
										</div>
										{/* Update Button */}
										<button
											onClick={() => handleUpdateWorkFlow(flow)}
											className="text-white font-semibold px-4 py-2 rounded-md text-xs sm:text-sm focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600 w-full sm:w-auto"
										>
											{flowUpdateLoader ? "Updating..." : "Update"}
										</button>
									</div>
								</div>
							)}
						</div>
					))}
				</div>

				{/* Reviews + Reviews Job Flow */}
				<div className="bg-white shadow-md rounded-lg p-4 sm:p-6 w-full mb-4 sm:mb-6">
					<h3 className="text-lg sm:text-xl font-semibold mb-2">Reviews</h3>
					<p className="text-gray-700 text-sm sm:text-base">
						Know what guests are saying about your property !!
					</p>

					<div className="flex justify-end mt-4 bg-gray-50 p-2 rounded-md">
						<button
							onClick={toggleExpandReviews}
							className="text-indigo-500 hover:text-indigo-700 flex items-center text-sm"
						>
							{isExpandedReviews ? (
								<>
									View Less <CgChevronUp className="ml-1" />
								</>
							) : (
								<>
									View All <CgChevronDown className="ml-1" />
								</>
							)}
						</button>
					</div>

					{isExpandedReviews && (
						<div className="mt-4 bg-gray-50 p-3 sm:p-4 rounded-lg">
							<div className="mb-4 mt-4">
								<div className="mb-2 flex items-center justify-between gap-3">
									<p className="font-bold text-sm sm:text-base">
										When to redirect guest to google reviews?
									</p>
									<Switch
										checked={reviewsFlow.reviewsEnabled}
										onChange={(checked) =>
											setReviewsFlow((prev) => ({
												...prev,
												reviewsEnabled: checked,
											}))
										}
										className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
									>
										<span
											aria-hidden="true"
											className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
										/>
									</Switch>
								</div>

								<select
									value={
										reviewsFlow.reviewsEnabled
											? reviewsFlow.startLimitForReviewLink
											: ""
									}
									onChange={(e) =>
										setReviewsFlow((prev) => ({
											...prev,
											startLimitForReviewLink: e.target.value,
										}))
									}
									disabled={!reviewsFlow.reviewsEnabled}
									className="border border-gray-300 rounded-md p-2 text-sm sm:text-base w-full disabled:bg-gray-100 disabled:text-gray-500"
								>
									{!reviewsFlow.reviewsEnabled && (
										<option value="">Turn on Reviews to enable redirect</option>
									)}
									{redirectOptions.map((option) => (
										<option key={option.value} value={option.value}>
											{option.label}
										</option>
									))}
								</select>
							</div>

							<div className="mt-5 border-t border-gray-200 pt-4">
								<h4 className="text-base sm:text-lg font-semibold mb-1">
									Reviews Job Flow
								</h4>
								<p className="text-gray-700 text-sm sm:text-base">
									Manage review jobs for different networks. Add review page URLs
									for each platform.
								</p>

							</div>

								<div className="mt-4 bg-white p-3 sm:p-4 rounded-lg">
							{/* Add Review Job Form */}
							<div className="mb-4 sm:mb-6">
								<h4 className="text-gray-700 font-bold mb-3 text-sm sm:text-base">
									Add New Review Job
								</h4>
								<div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 mb-4">
									<div>
										<label className="block text-sm font-medium text-gray-700 mb-1">
											Network
										</label>
										<select
											value={newReviewJob.network}
											onChange={(e) =>
												setNewReviewJob({
													...newReviewJob,
													network: e.target.value,
												})
											}
											className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
										>
											<option value="">Select Network</option>
											{getAvailableNetworks().map((network) => (
												<option key={network.value} value={network.value}>
													{network.label}
												</option>
											))}
										</select>
									</div>
									<div>
										<div className="relative group cursor-pointer">
											<label className="block text-sm font-medium text-gray-700 mb-1">
												Review Page URL{" "}
												<Info size={14} className="ml-1 inline-block" />
											</label>
											<div className="absolute left-24 top-full mt-1 w-max max-w-xs bg-gray-800 text-white text-xs rounded px-2 py-1 z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-normal shadow-lg">
												Paste Actual Platform review page url here
												<br />
												{newReviewJob.network ? "For Example:" : ""}
												{newReviewJob.network === "tripadvisor"
													? "https://www.tripadvisor.in/Hotel_Review-g60713-d12290636-Reviews-Warfield_Hotel-San_Francisco_California.html"
													: newReviewJob.network === "google"
														? "https://www.google.com/maps?cid=472717649119152494"
														: newReviewJob.network === "booking"
															? "https://www.booking.com/hotel/us/warfield.en-gb.html"
															: newReviewJob.network === "expedia"
																? "https://www.expedia.co.in/San-Francisco-Hotels-Warfield-Hotel.h17383168.Hotel-Information"
																: newReviewJob.network === "agoda"
																	? "https://www.agoda.com/warfield-hotel_2/hotel/san-francisco-ca-us.html"
																	: newReviewJob.network === "yelp"
																		? "https://www.yelp.com/biz/warfield-hotel-san-francisco"
																		: ""}
											</div>
										</div>

										<input
											type="url"
											placeholder="https://example.com/reviews"
											value={newReviewJob.networkUrl}
											onChange={(e) =>
												setNewReviewJob({
													...newReviewJob,
													networkUrl: e.target.value,
												})
											}
											className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
										/>
									</div>
									<div>
										<div className="relative group cursor-pointer">
											<label className="block text-sm font-medium text-gray-700 mb-1">
												Redirect URL{" "}
												<Info size={14} className="ml-1 inline-block" />
											</label>
											<div className="absolute left-24 top-full mt-1 w-max max-w-xs bg-gray-800 text-white text-xs rounded px-2 py-1 z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-normal shadow-lg">
												Paste Link where you want customer to navigate
											</div>
										</div>

										<input
											type="url"
											placeholder="https://example.com/redirect/reviews"
											value={newReviewJob.redirectUrl}
											onChange={(e) =>
												setNewReviewJob({
													...newReviewJob,
													redirectUrl: e.target.value,
												})
											}
											className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
										/>
									</div>
								</div>
								<button
									onClick={handleAddReviewJob}
									disabled={
										isAddingReviewJob ||
										!newReviewJob.network ||
										!newReviewJob.networkUrl ||
										!newReviewJob.redirectUrl
									}
									className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-400 text-white font-medium py-2 px-4 text-sm sm:text-base rounded-md transition-colors w-full sm:w-auto"
								>
									{isAddingReviewJob ? "Adding..." : "Add Review Job"}
								</button>
							</div>

							{/* Review Jobs List */}
							<div>
								<h4 className="text-gray-700 font-bold mb-3 text-sm sm:text-base">
									Existing Review Jobs
								</h4>
								{reviewsJobFlow.reviewJobs.length === 0 ? (
									<p className="text-gray-500 text-sm">
										No review jobs added yet.
									</p>
								) : (
									<div className="space-y-3">
										{reviewsJobFlow.reviewJobs.map((job) => (
											<div
												key={job._id || job.id}
												className="bg-white rounded-md border p-3 sm:p-4"
											>
												{editingJobId === job._id ? (
													// Edit Mode
													<div className="space-y-3">
														<div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
															<div>
																<label className="block text-sm font-medium text-gray-700 mb-1">
																	Network
																</label>
																<select
																	value={editingReviewJob.network}
																	disabled={true}
																	onChange={(e) =>
																		setEditingReviewJob({
																			...editingReviewJob,
																			network: e.target.value,
																		})
																	}
																	className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
																>
																	<option value="">Select Network</option>
																	{getAvailableNetworksForEdit(job.network).map(
																		(network) => (
																			<option
																				key={network.value}
																				value={network.value}
																			>
																				{network.label}
																			</option>
																		),
																	)}
																</select>
															</div>
															{/* <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Review Page URL
                                </label>
                                <input
                                  type="url"
                                  placeholder="https://example.com/reviews"
                                  value={editingReviewJob.networkUrl}
                                  onChange={(e) =>
                                    setEditingReviewJob({
                                      ...editingReviewJob,
                                      networkUrl: e.target.value,
                                    })
                                  }
                                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
                                />
                              </div> */}
															<div>
																<label className="block text-sm font-medium text-gray-700 mb-1">
																	Redirect URL
																</label>
																<input
																	type="url"
																	placeholder="https://example.com/redirect/reviews"
																	value={editingReviewJob.redirectUrl}
																	onChange={(e) =>
																		setEditingReviewJob({
																			...editingReviewJob,
																			redirectUrl: e.target.value,
																		})
																	}
																	className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
																/>
															</div>
														</div>
														<div className="flex flex-col sm:flex-row gap-2">
															<button
																onClick={handleUpdateReviewJob}
																disabled={
																	isUpdatingReviewJob ||
																	!editingReviewJob.redirectUrl
																}
																className="bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white font-medium py-2 px-4 rounded-md transition-colors text-sm w-full sm:w-auto"
															>
																{isUpdatingReviewJob
																	? "Updating..."
																	: "Save Changes"}
															</button>
															<button
																onClick={handleCancelEdit}
																disabled={isUpdatingReviewJob}
																className="bg-gray-500 hover:bg-gray-600 disabled:bg-gray-400 text-white font-medium py-2 px-4 rounded-md transition-colors text-sm w-full sm:w-auto"
															>
																Cancel
															</button>
														</div>
													</div>
												) : (
													// View Mode
													<div>
														<div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-3">
															<div className="flex flex-wrap items-center gap-2 sm:gap-3">
																<span className="font-medium text-gray-900 capitalize text-base sm:text-lg">
																	{job.network}
																</span>
																<span className="text-xs bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full">
																	{job.reviewJobId || "No Job ID"}{" "}
																	{job.isDefault}
																</span>
															</div>
															<div className="flex gap-2 w-full sm:w-auto">
																<button
																	onClick={() => handleEditReviewJob(job)}
																	className="text-blue-500 hover:text-blue-700 p-1"
																	title="Edit review job"
																>
																	<svg
																		className="w-4 h-4"
																		fill="none"
																		stroke="currentColor"
																		viewBox="0 0 24 24"
																	>
																		<path
																			strokeLinecap="round"
																			strokeLinejoin="round"
																			strokeWidth={2}
																			d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
																		/>
																	</svg>
																</button>
																<div className="flex items-center">
																	<input
																		id="is-default"
																		name="is-default"
																		type="checkbox"
																		className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
																		checked={job.isDefault}
																		onChange={(e) => {
																			handleIsDefault(
																				job._id,
																				e.target.checked,
																			);
																		}}
																	/>
																	<label
																		htmlFor="remember-me"
																		className="ml-2 block text-sm leading-6 text-gray-700"
																	>
																		Default
																	</label>
																</div>
																<button
																	onClick={() =>
																		setConfirmModal({ open: true, review: job })
																	}
																	className="text-red-500 hover:text-red-700 p-1"
																	title="Delete review job"
																>
																	<FaTrash className="w-4 h-4" />
																</button>
															</div>
														</div>

														<div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 text-xs sm:text-sm">
															<div>
																<span className="font-medium text-gray-700">
																	Review Page URL:
																</span>
																<p className="text-gray-600 break-all text-xs sm:text-sm">
																	{job.networkUrl ||
																		job.networkUrl ||
																		"Not provided"}
																</p>
															</div>
															<div>
																<span className="font-medium text-gray-700">
																	UID:
																</span>
																<p className="text-gray-600 font-mono text-xs break-all">
																	{job.uid || "Not available"}
																</p>
															</div>
															<div>
																<span className="font-medium text-gray-700">
																	Slug:
																</span>
																<p className="text-gray-600 font-mono text-xs break-all">
																	{job.slug || "Not available"}
																</p>
															</div>
															<div>
																<span className="font-medium text-gray-700">
																	Job ID:
																</span>
																<p className="text-gray-600 font-mono text-xs break-all">
																	{job.reviewJobId || "Not available"}
																</p>
															</div>
															<div>
																<span className="font-medium text-gray-700">
																	Redirect URL:
																</span>
																<p className="text-gray-600 break-all text-xs sm:text-sm">
																	{job.redirectUrl ||
																		job.redirectUrl ||
																		"Not provided"}
																</p>
															</div>
														</div>
													</div>
												)}
											</div>
										))}
									</div>
								)}
							</div>
								</div>
						</div>
					)}
				</div>

				{/* New Flow Modal */}
				{isNewFlowModalOpen && <NewFlowModal onClose={closeNewFlowModal} />}
			</div>
			<ConfirmModal
				open={confirmModal.open}
				review={confirmModal.review}
				onConfirm={handleDeleteReviewJob}
				onCancel={() => setConfirmModal({ open: false, review: null })}
			/>
		</>
	);
};
